import { axiosAuthInstance, axiosInstance } from "../config/axios-config";

import Cookies from "js-cookie";
import { useCommunitiesStore } from "../store/communities.store";
import { useUserStore } from "../store/user.store";

// import { history } from "..";

// import { showAlertModal } from "../jsx/pages/trybz_dashboard/_components/customModals/AlertModal";

var AuthService = {
  refreshToken: async function (failedRequest) {
    const refresh_token = Cookies.get("refresh_token");
    if (refresh_token !== undefined)
      return axiosInstance
        .post("/auth/refresh", { refreshToken: refresh_token })
        .then((res) => {
          Cookies.set("access_token", res.data.accessToken);
          Cookies.set("refresh_token", res.data.refreshToken);
          Cookies.set("TrybzExpToken", res.data.expiresAt);

          failedRequest.response.config.headers["Authorization"] =
            "Bearer " + res.data;
          return Promise.resolve();
        });
  },

  login: async function (email, password) {
    return await axiosInstance
      .post("/auth/login", { email: email, password: password })
      .then(async (res) => {
        console.log(res.data.accessToken);
        Cookies.set("access_token", res.data.accessToken);
        Cookies.set("refresh_token", res.data.refreshToken);
        useUserStore.setState({
          isLoggedIn: true,
          hasSetpassword: res.data.hasSetPassword,
          hasLoggedInBefore: res.data.hasLoggedInBefore,
        });
        Cookies.set("TrybzExpToken", res.data.expiresAt);

        return res.data;
      });
  },

  verifyPassword: async function (password) {
    return await axiosAuthInstance
      .post("/auth/password/verify", { password: password })
      .then(async (res) => {
        return res.data;
      });
  },

  logout: function () {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    Cookies.remove("TrybzExpToken");
    useUserStore.setState({
      hasSetpassword: false,
      isLoggedIn: false,
      user: null,
      activeRole: null,
      isImpersonating: false,
      currentPath: "",
    });
    useCommunitiesStore.setState({
      communityId: "",
      communityData: null,
    });
    localStorage.clear();
  },

  forgotPassword: async function (email) {
    return await axiosInstance.post("/auth/password/forgot", {
      email: email,
    });
  },

  changePassword: async function (input) {
    return await axiosAuthInstance.put("/auth/password", { ...input });
  },

  resetPassword: async function (input) {
    return await axiosAuthInstance.post("/auth/password/reset", { ...input });
  },

  sendOtp: async function (phoneNumber) {
    return await axiosAuthInstance.post("/auth/otp/send", {
      phoneNumber: phoneNumber,
    });
  },

  verifyOtp: async function (input) {
    return await axiosAuthInstance
      .post("/auth/otp/verify", { ...input })
      .then(async (res) => {
        return res.data;
      });
  },

  initiateEmailChange: async function (newEmail) {
    return await axiosAuthInstance.post("/auth/email/change/initiate", {
      newEmail: newEmail,
    });
  },

  confirmEmailChange: async function (input) {
    return await axiosInstance.post("/auth/email/change/confirm", { ...input });
  },

  initiatePhoneChange: async function () {
    return await axiosAuthInstance.post("/auth/phone/change/initiate");
  },

  confirmPhoneChange: async function (input) {
    return await axiosInstance.post("/auth/phone/change/confirm", { ...input });
  },

  initiatePasswordChange: async function () {
    return await axiosAuthInstance.post("/auth/password/change/initiate");
  },
};

export default AuthService;
